"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var package_json_1 = __importDefault(require("../package.json"));
// overridden in posthog-core,
// e.g.     Config.DEBUG = Config.DEBUG || instance.config.debug
var Config = {
    DEBUG: false,
    LIB_VERSION: package_json_1.default.version,
};
exports.default = Config;
//# sourceMappingURL=config.js.map